import React from 'react'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import Broken from '../Broken'

import { useTranslation } from 'language/translator'
import { TParsedError } from 'utils/errorParser'
import { TCoreWidget } from 'types/GlobalWidget'

interface FetchErrorProps {
  error: TParsedError
  fetchWidgetData?: (widget: TCoreWidget) => void
  scaleFactor: number
  widget: TCoreWidget
}

const FetchError = (props: FetchErrorProps) => {
  const { error, fetchWidgetData, scaleFactor, widget } = props
  const { t } = useTranslation()

  // Handle specific known error types
  if (error.detail === 'DATE_RANGE_OUT_OF_BOUNDS') {
    return (
      <EmptyPlaceholder
        background={true}
        scaleFactor={scaleFactor}
        title={t('widgets', 'date_range_out_of_bounds_error')}
        body={t('widgets', 'date_range_out_of_bounds_description')}
        icon="HeartBrokenTwoTone"
      />
    )
  }

  // Generic/unknown error
  return (
    <Broken
      fetchWidgetData={fetchWidgetData}
      scaleFactor={scaleFactor}
      widget={widget}
    />
  )
}

export default FetchError
